import { render } from "./AllocationCard.vue?vue&type=template&id=972ec39e"
import script from "./AllocationCard.vue?vue&type=script&lang=js"
export * from "./AllocationCard.vue?vue&type=script&lang=js"

import "./AllocationCard.vue?vue&type=style&index=0&id=972ec39e&lang=sass"
script.render = render

export default script